/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const ornamentTokens = {
  ForegroundColorNeutralDefault: '#ffffff',
  ForegroundColorPositiveDefault: '#ffffff',
  ForegroundColorNegativeDefault: '#ffffff',
  ForegroundColorNoticeDefault: '#ffffff',
  ForegroundColorPendingDefault: '#000000',
  ForegroundColorInformationalDefault: '#ffffff',
  ForegroundColorStaffDefault: '#ffffff',
  ForegroundColorGrayDefault: '#232b2b',
  ForegroundColorGrayDarkerDefault: '#ffffff',
  ForegroundColorBlueLightestDefault: '#285da3',
  ForegroundColorBlueLightDefault: '#1a3e6d',
  ForegroundColorBlueDefault: '#ffffff',
  ForegroundColorGreenLightestDefault: '#237c70',
  ForegroundColorGreenDefault: '#ffffff',
  ForegroundColorSlateDefault: '#ffffff',
  ForegroundColorRedDefault: '#ffffff',
  ForegroundColorYellowDefault: '#5b4b34',
  ForegroundColorBrownDefault: '#ffffff',
  ForegroundColorOrangeDefault: '#ffffff',
  ForegroundColorLimeDefault: '#384202',
  ForegroundColorWhiteDefault: '#232b2b',
  ForegroundSizeSmallDefault: '14px',
  ForegroundSizeMediumDefault: '16px',
  ForegroundSizeLargeDefault: '18px',
  BackgroundColorNeutralDefault: '#c4c4c4',
  BackgroundColorPositiveDefault: '#32b0a0',
  BackgroundColorNegativeDefault: '#da1c3c',
  BackgroundColorNoticeDefault: '#e57b5a',
  BackgroundColorPendingDefault: '#f8d648',
  BackgroundColorInformationalDefault: '#2c67b5',
  BackgroundColorStaffDefault: '#e57b5a',
  BackgroundColorGrayDefault: '#c4c4c4',
  BackgroundColorGrayDarkerDefault: '#656b6b',
  BackgroundColorBlueLightestDefault: '#dfe8f4',
  BackgroundColorBlueLightDefault: '#8babd6',
  BackgroundColorBlueDefault: '#285da3',
  BackgroundColorGreenLightestDefault: '#addfd9',
  BackgroundColorGreenDefault: '#32b0a0',
  BackgroundColorSlateDefault: '#232b2b',
  BackgroundColorRedDefault: '#da1c3c',
  BackgroundColorYellowDefault: '#f8d648',
  BackgroundColorBrownDefault: '#a4875d',
  BackgroundColorOrangeDefault: '#e57b5a',
  BackgroundColorLimeDefault: '#b1d636',
  BackgroundColorWhiteDefault: '#ffffff',
  BackgroundSizeSmallDefault: '24px',
  BackgroundSizeMediumDefault: '32px',
  BackgroundSizeLargeDefault: '38px',
  BackgroundBorderRadiusBaseDefault: '50%',
  BackgroundBorderWidthBaseDefault: '1px',
  BackgroundBorderStyleInverseDefault: 'solid',
  BackgroundBorderStyleDashedDefault: 'dashed',
} as const;
